import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import sanityClient from "../Client";
import * as FIIcons from "react-icons/fi";

const transition = {
  duration: 0.25,
  delay: 0.05,
  ease: [0, 0.71, 0.2, 1.01],
};

const dropdown = {
  hidden: {
    opacity: 0,
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
  },
  show: {
    opacity: 1,
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
    transition: {
      delayChildren: 0.75,
      staggerChildren: 0.1,
    },
  },
};

const answer = {
  hidden: {
    opacity: 0.75,
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
  },
  show: {
    opacity: 1,
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
  },
  exit: {
    opacity: 0,
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
  },
};

const Capability = () => {
  const ref = useRef(null);
  const [capablitiesData, setCapabilitiesData] = useState(null);
  const [clicked, setClicked] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 480) setIsMobile(true);
  }, []);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "capabilities"] {
                header,
                response,
                slogan,
            }`
      )
      .then((data) =>
        setCapabilitiesData(
          data?.sort((a, b) => (a.header > b.header ? 1 : -1))
        )
      )
      .catch(console.error);
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setClicked(false);
    }
  };

  const handleClick = (index) => {
    if (clicked === index) {
      setClicked(null);
    }
    setClicked(index);
  };

  return (
    <div className="capabilities-container">
      {!isMobile && (
        <div className="capabilities-slogan">
          {capablitiesData?.map((item, index) => {
            if (!clicked && index === 0) {
              return <h2 key={index}>{item.slogan}</h2>;
            } else if (clicked === index) {
              return <h2 key={index}>{item.slogan}</h2>;
            } else {
              return null;
            }
          })}
        </div>
      )}
      <div className="item-container">
        {capablitiesData?.map((item, index) => (
          <div key={index}>
            <motion.div
              className="wrapper"
              onClick={() => handleClick(index)}
              key={index}
            >
              <h2>{item.header}</h2>
              <span>
                {!clicked && index === 0 ? (
                  <FIIcons.FiMinus />
                ) : clicked === index ? (
                  <FIIcons.FiMinus />
                ) : (
                  <FIIcons.FiPlus />
                )}
              </span>
            </motion.div>
            {!clicked && index === 0 ? (
              <motion.div
                className="dropdown"
                variants={dropdown}
                initial="hidden"
                animate="show"
                exit="exit"
              >
                <motion.p
                  variants={answer}
                  transition={{ ...transition }}
                  data-scroll
                  data-scroll-delay="0.13"
                  data-scroll-speed="4"
                >
                  {item.response}
                </motion.p>
                {isMobile && (
                  <div className="capabilities-slogan">
                    {capablitiesData?.map((item, index) => {
                      if (!clicked && index === 0) {
                        return <h2 key={index}>{item.slogan}</h2>;
                      } else if (clicked === index) {
                        return <h2 key={index}>{item.slogan}</h2>;
                      } else {
                        return null;
                      }
                    })}
                  </div>
                )}
              </motion.div>
            ) : clicked === index ? (
              <motion.div
                className="dropdown"
                variants={dropdown}
                initial="hidden"
                animate="show"
                exit="exit"
              >
                <motion.p
                  variants={answer}
                  transition={{ ...transition }}
                  data-scroll
                  data-scroll-delay="0.13"
                  data-scroll-speed="4"
                >
                  {item.response}
                </motion.p>
                {isMobile && (
                  <div className="capabilities-slogan">
                    {capablitiesData?.map((item, index) => {
                      if (!clicked && index === 0) {
                        return <h2 key={index}>{item.slogan}</h2>;
                      } else if (clicked === index) {
                        return <h2 key={index}>{item.slogan}</h2>;
                      } else {
                        return null;
                      }
                    })}
                  </div>
                )}
              </motion.div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Capability;
